<div class="row">
  <div class="col">
    <button type="button" class="btn btn-link float-end" (click)="openNewTab()">
      <span class="fas fa-external-link"></span>
      Open in new tab
    </button>
  </div>
</div>

@if (state.isReady()) {
  <div class="scrollable">
    <img [src]="src" />
  </div>
} @else {
  <ch-status [state]="state"></ch-status>
}
